import { RoutineFrequencyType } from "@pages/Routines/RoutineFrequency/RoutineFrequency";
import { t } from "i18next";

import { decodeFrequency } from "@src/utils/FrequencyDecoder";
import { FrequencyUtilities } from "../../../../../utils/frequencyUtilities";
import { RoutineData } from "../../../Routines/RoutineData";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { DataObjectField, DecodeStringContext } from "../DataObjectField";
import { FirebaseDataNumberField } from "../Generic/FirebaseDataNumberField";

export class RoutineDataFrequencyField<FirebaseDataType extends DataObjectType> extends DataObjectField<RoutineFrequencyType, FirebaseDataType> {
  encodeString = (value: RoutineFrequencyType) => {
    return FrequencyUtilities.convertFrequencyToString(value);
  };
  decodeString = (value: string, context?: DecodeStringContext) => {
    const defaultEach = context?.stringValues?.each;
    const parsedValue = defaultEach ? parseInt(defaultEach) : undefined;
    return decodeFrequency(value, context?.stringValues?.startDate, parsedValue && !isNaN(parsedValue) ? parsedValue : undefined);
  };

  encode = (value: RoutineFrequencyType) => {
    return value;
  };
  decode = (value: any) => {
    return typeof value === "object" ? value : decodeFrequency(typeof value === "string" ? value : "");
  };

  getReadableStringRepresentation(value: RoutineFrequencyType): string {
    return FrequencyUtilities.convertFrequencyToString(value);
  }

  allComparators: DataObjectFieldComparator[] = ["is-known", "is-unknown"];

  override isValueValid = (value: any): boolean => {
    return typeof value === "object";
  };
}

export class RoutineDataDeadlineDelayField extends FirebaseDataNumberField<RoutineData> {
  getReadableStringRepresentation(value: number): string {
    return super.getReadableStringRepresentation(value) + " " + t("main.daysAfterTaskDate").toLowerCase();
  }
}
export class RoutineDataCreateDaysBeforeField extends FirebaseDataNumberField<RoutineData> {
  getReadableStringRepresentation(value: number): string {
    return super.getReadableStringRepresentation(value) + " " + t("main.daysBeforeTaskDate").toLowerCase();
  }
}

/*
export class RoutineDataPropertiesField<FirebaseDataType extends DataObjectType> extends DataObjectField<RoutinePropertyData, FirebaseDataType> {
  encodeString = (value: RoutinePropertyData) => {
    return value.data.id;
  };
  decodeString = (value: string, context?: DecodeStringContext) => {
    return { data: LocalData.properties.addData(value) } as RoutinePropertyData;
  };

  encode = (value: RoutinePropertyData) => {
    const data: {[key: string]: any} = {
      data: value.data.id,
      units: value.units.map(unit => unit.id),
      collections: {}
    };
    for (const collection of Object.keys(value.collections)) {
      data.collections[collection ] = value.collections[collection].map(item => item.id);
    }
    return data;
  };

  decode = (value: any) => {
    if (typeof value === "string") return  {
      data: LocalData.properties.addData(value),
      units: [],
      collections: {}
    };

    return undefined
  };

  getReadableStringRepresentation(value: RoutinePropertyData): string {
   let propertiesTenantsList = "";
    let property = value.data;
    if (!property.deleted && property.name) {
      propertiesTenantsList += property.name;
      for (let j = 0; j < value.units.length; j++) {
        let unit = value.units[j];
        if (unit.property === property) {
          if (j === 0) {
            propertiesTenantsList += " (" + unit.name;
          } else {
            propertiesTenantsList += ", " + unit.name;
          }
          if (j + 1 === value.units.length) {
            propertiesTenantsList += ")";
          }
        }
      }
    }
  
    return propertiesTenantsList
  }

  override singleInputElement = (
    value: RoutinePropertyData | undefined,
    setValue: (value: RoutinePropertyData | undefined) => void,
    context?: InputElementContext
  ) => {
    return (
      <div /*className={styles.section}>
        <div /*className={styles.inputField}>
          <PropertySelector
            width="100%"
            className={styles.settingsSelector}
            placeholder={t('main.selectProperty')}
            properties={LocalData.currentUser.properties}
            isMulti={true}
            defaultSelected={this.state.properties}
            changedSelectedProperties={(properties) => {
              this.setState({ properties: properties });
            }}
          />
        </div>
        <div /*className={styles.inputField}>
          <table /*id={styles.tenantTable}>
            <tbody>
              {value.properties.map((property) => {
                if (!property.deleted && property.name) {
                  let selectedTenants: UnitData[] = [];
                  property.units.forEach((unit) => {
                    if (property.units.includes(unit) && this.state.tenants.includes(unit)) {
                      selectedTenants.push(unit);
                    }
                  });
                  return (
                    <tr key={property.id} className={styles.tenantSelectField}>
                      <td className={styles.tenantSelectLabelCell}>
                        <Label text={property.name} type="paragraph" className={styles.tenantSelectLabel} />
                      </td>
                      <td>
                        <TenantSelector
                          className={styles.tenantSelect}
                          width="100%"
                          placeholder={t('main.notSpecified')}
                          properties={[property]}
                          defaultSelected={selectedTenants}
                          isMulti={true}
                          changedSelectedTenants={(tenants) => this.addTenants(tenants, property)}
                        />
                      </td>
                    </tr>
                  );
                }
                return undefined;
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  allComparators: DataObjectFieldComparator[] = ["is-known", "is-unknown"];
}
*/

